export enum GmlRadiusUom {
  M = "m",
  KM = "km",
  NM = "[nmi_i]"
}
